import styled from 'styled-components'

interface IExporterStyledProps {}

export const ExporterStyled = styled.div<IExporterStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
